export default "__VITE_ASSET__BXOvTI9j__"